import { API_BASE } from '../../config/env';
import { httpConstants } from '../../constants';
import { httpService } from '../../utility/httpService';

export interface ChatQuery {
  report?: string;
  impact?: string;
  user_input?: string;
  user_query?: string;
}
export interface ChatMessage {
  id: string;
  query: ChatQuery;
  answer?: string;
  timeTaken?: number;
  metadata?: any;
  status?: string;
  files?: {
    data: Record<string, any>[];
  };
  created_at?: string;
  updated_at?: string;
  reportId?: string;
  report?: Record<string, any>;
  discoveryContent?: Record<string, any>;
  version?: string;
  impact?: string;
  fileSummary?: string;
  context_knowledge?: {
    data: Record<string, string>[];
  };
  semantic_knowledge?: Record<string, any>;
}

export interface ChatSession {
  data: ChatMessage[];
  total: number;
}

export interface VersionData {
  [version: string]: any;
}

export async function getUseCaseDetails(usecaseId: string): Promise<any> {
  const url = `${API_BASE}/api/v1/ideation/use-cases/${usecaseId}/`;

  try {
    const response = await httpService<any>(httpConstants.METHOD_TYPE.GET, url);
    return response;
  } catch (error) {
    console.error('Failed to fetch diagram data:', error);
    return undefined;
  }
}

export async function getChatHistory(usecaseId: string, field: string): Promise<any> {
  const url = `${API_BASE}/api/v1/ideation/query-history/${usecaseId}/?skip=0&limit=1000&sortingKey=created_at&sortingOrder=1&field_type=${field}`;

  try {
    const response = await httpService<any>(httpConstants.METHOD_TYPE.GET, url);
    return response;
  } catch (error) {
    console.error('Failed to fetch diagram data:', error);
    return undefined;
  }
}

export async function postQuery(payload: any): Promise<any | undefined> {
  const url = `${API_BASE}/api/v1/ideation/query-use-case/`;
  try {
    const response = await httpService<any>(httpConstants.METHOD_TYPE.POST, url, payload);
    console.log('Tech Landscape Diagram Response:', response);
    return response;
  } catch (error) {
    console.error('Failed to fetch tech landscape diagram:', error);
    return undefined;
  }
}

export async function editContent(payload: any): Promise<any> {
  const url = `${API_BASE}/api/v1/ideation/query-use-case/${payload.useCaseId}/`;
  try {
    const response = await httpService<any>(httpConstants.METHOD_TYPE.PUT, url, payload);
    return response;
  } catch (error) {
    console.error('Failed to edit content:', error);
    return error;
  }
}

export async function updateDraftStatus(useCaseId: string, payload: any): Promise<any> {
  const url = `${API_BASE}/api/v1/ideation/use-cases/${useCaseId}/`;
  try {
    const response = await httpService<any>(httpConstants.METHOD_TYPE.PATCH, url, payload);
    return response;
  } catch (error) {
    console.error('Failed to edit content:', error);
    return error;
  }
}

export const analyzeFile = async (
  fileUrl: string,
  fileName: string,
  fileId: string,
  fileSize: string
) => {
  try {
    const response = await fetch(
      'https://orchestrator.zbrain.ai/api/v1/webhooks/W91ZYTPoDSpwT6jQalIWk/sync?tenantId=6764029052789d00255f17a1',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer za-U2FsdGVkX1/ttZ/pUsCjolOeYbHP4uWJKYu0O860+8yYE6ebW6DvrABLSug5Qkw4DIVv+2HmxvP3kq9t+WtL3P4Wt1KaaAc43piiuclp840Ek1C9ibGtQGD44w9fTXuK',
        },
        body: JSON.stringify({
          files: [
            {
              id: fileId,
              fileUrl: fileUrl,
              fileName: fileName,
              fileData: '',
              fileSize: fileSize,
              fileSummary: '',
              env: 'development',
            },
          ],
        }),
      }
    );

    if (!response.ok) {
      throw new Error('Failed to analyze file');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error analyzing file:', error);
    throw error;
  }
};

export async function getPreviousSessions(useCaseId: string): Promise<any> {
  const url = `https://api.zbrain.ai/contentms/chat/sessions/${useCaseId}?appId=6914205061cec0b268eba06b&tenantId=6764029052789d00255f17a1`;

  try {
    const response = await httpService<any>(httpConstants.METHOD_TYPE.GET, url);
    return response;
  } catch (error) {
    console.error('Failed to fetch diagram data:', error);
    return undefined;
  }
}
